import { c as _c } from "react/compiler-runtime";
import { NumericFormat } from "react-number-format";
import styles from "./WealthCalculator.module.scss";
import { EffektDropdown } from "../../../shared/components/EffektDropdown/EffektDropdown";
import { EffektButton, EffektButtonVariant } from "../../../shared/components/EffektButton/EffektButton";
import { LoadingButtonSpinner } from "../../../shared/components/Spinner/LoadingButtonSpinner";
import { useCallback, useRef, useState } from "react";
export type WealthCalculatorInputConfiguration = {
  subtitle_label?: string;
  income_input_configuration: {
    placeholder?: string;
    thousand_separator?: string;
    currency_label?: string;
    description?: string;
  };
  children_input_configuration: {
    placeholder?: string;
    options: string[];
  };
  adults_input_configuration: {
    placeholder?: string;
    options: string[];
  };
  calculate_button_label?: string;
};
export const WealthCalculatorInput: React.FC<{
  title: string;
  incomeInput: number[] | undefined;
  setIncomeInput: (values: number[]) => void;
  numberOfChildren: number;
  setNumberOfChildren: (value: number) => void;
  numberOfAdults: number;
  setNumberOfParents: (value: number) => void;
  loadingPostTaxIncome: boolean;
  config: WealthCalculatorInputConfiguration;
}> = t0 => {
  const $ = _c(60);
  const {
    title,
    setIncomeInput,
    numberOfChildren,
    setNumberOfChildren,
    numberOfAdults,
    setNumberOfParents,
    loadingPostTaxIncome,
    config
  } = t0;
  const calculateButtonRef = useRef(null);
  let t1;
  if ($[0] !== config.adults_input_configuration.options.length) {
    t1 = () => Array.from({
      length: config.adults_input_configuration.options.length
    }, _temp);
    $[0] = config.adults_input_configuration.options.length;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [adultIncomes, setAdultIncomes] = useState(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (calculateButtonRef.current) {
        window.scrollTo({
          top: calculateButtonRef.current.offsetTop + calculateButtonRef.current.clientHeight + 60,
          behavior: "smooth"
        });
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const scrollToOutput = t2;
  const placeholderIncome = config.income_input_configuration.placeholder || "Income before tax (adult {{count}})";
  let t3;
  if ($[3] !== title) {
    t3 = <h5>{title}</h5>;
    $[3] = title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== config.subtitle_label) {
    t4 = <span className={styles.calculator__input__subtitle}>{config.subtitle_label}</span>;
    $[5] = config.subtitle_label;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== adultIncomes || $[8] !== numberOfAdults) {
    let t6;
    if ($[10] !== adultIncomes) {
      t6 = (_, index) => adultIncomes[index] || 0;
      $[10] = adultIncomes;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    t5 = Array.from({
      length: numberOfAdults
    }, t6);
    $[7] = adultIncomes;
    $[8] = numberOfAdults;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[12] !== adultIncomes || $[13] !== config.income_input_configuration.currency_label || $[14] !== config.income_input_configuration.thousand_separator || $[15] !== numberOfAdults || $[16] !== placeholderIncome || $[17] !== setIncomeInput || $[18] !== t5) {
    t6 = t5.map((adultIncome, index_0) => <div className={styles.calculator__input__group__input__income__wrapper} key={index_0}><NumericFormat type="tel" placeholder={placeholderIncome.replace("{{count}}", (index_0 + 1).toString())} value={adultIncome || ""} className={styles.calculator__input__group__input__text} thousandSeparator={config.income_input_configuration.thousand_separator} decimalSeparator={config.income_input_configuration.thousand_separator === "." ? "," : "."} onValueChange={values => {
        const nextIncomes = adultIncomes.map((income, incomeIndex) => incomeIndex === index_0 ? values.floatValue || 0 : income);
        setAdultIncomes(nextIncomes);
        setIncomeInput(nextIncomes.slice(0, numberOfAdults));
      }} /><span>{config.income_input_configuration.currency_label}</span></div>);
    $[12] = adultIncomes;
    $[13] = config.income_input_configuration.currency_label;
    $[14] = config.income_input_configuration.thousand_separator;
    $[15] = numberOfAdults;
    $[16] = placeholderIncome;
    $[17] = setIncomeInput;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== config.income_input_configuration.description) {
    t7 = <i>{config.income_input_configuration.description}</i>;
    $[20] = config.income_input_configuration.description;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t6 || $[23] !== t7) {
    t8 = <div className={styles.calculator__input__group} data-cy="wealthcalculator-income-input">{t6}{t7}</div>;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  const t9 = config.adults_input_configuration.placeholder || "Adults in household";
  let t10;
  if ($[25] !== config.adults_input_configuration.options) {
    t10 = config.adults_input_configuration.options || [];
    $[25] = config.adults_input_configuration.options;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  const t11 = config.adults_input_configuration.options[numberOfAdults - 1];
  let t12;
  if ($[27] !== adultIncomes || $[28] !== config.adults_input_configuration.options || $[29] !== setIncomeInput || $[30] !== setNumberOfParents) {
    t12 = val => {
      const nextNumberOfAdults = config.adults_input_configuration.options.indexOf(val) + 1;
      setNumberOfParents(nextNumberOfAdults);
      setIncomeInput(adultIncomes.slice(0, nextNumberOfAdults));
    };
    $[27] = adultIncomes;
    $[28] = config.adults_input_configuration.options;
    $[29] = setIncomeInput;
    $[30] = setNumberOfParents;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t10 || $[33] !== t11 || $[34] !== t12 || $[35] !== t9) {
    t13 = <div className={styles.calculator__input__group} data-cy="wealthcalculator-adults-input"><EffektDropdown placeholder={t9} options={t10} value={t11} onChange={t12} /></div>;
    $[32] = t10;
    $[33] = t11;
    $[34] = t12;
    $[35] = t9;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  const t14 = config.children_input_configuration.placeholder || "Children in household";
  let t15;
  if ($[37] !== config.children_input_configuration.options) {
    t15 = config.children_input_configuration.options || [];
    $[37] = config.children_input_configuration.options;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  const t16 = config.children_input_configuration.options[numberOfChildren];
  let t17;
  if ($[39] !== config.children_input_configuration.options || $[40] !== setNumberOfChildren) {
    t17 = val_0 => setNumberOfChildren(config.children_input_configuration.options.indexOf(val_0));
    $[39] = config.children_input_configuration.options;
    $[40] = setNumberOfChildren;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t14 || $[43] !== t15 || $[44] !== t16 || $[45] !== t17) {
    t18 = <div className={styles.calculator__input__group} data-cy="wealthcalculator-children-input"><EffektDropdown placeholder={t14} options={t15} value={t16} onChange={t17} /></div>;
    $[42] = t14;
    $[43] = t15;
    $[44] = t16;
    $[45] = t17;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = [styles.calculator__input__group, styles.calculator__input__group_mobile];
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== loadingPostTaxIncome) {
    t20 = loadingPostTaxIncome && <span className={styles.calculator__input__calculate__spinner} data-cy="wealthcalculator-calculate-spinner"><LoadingButtonSpinner /></span>;
    $[48] = loadingPostTaxIncome;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== config.calculate_button_label || $[51] !== t20) {
    t21 = <div className={t19.join(" ")} ref={calculateButtonRef}><EffektButton onClick={scrollToOutput} variant={EffektButtonVariant.SECONDARY}><span className={styles.calculator__input__calculate__label}>{config.calculate_button_label}{t20}</span></EffektButton></div>;
    $[50] = config.calculate_button_label;
    $[51] = t20;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] !== t13 || $[54] !== t18 || $[55] !== t21 || $[56] !== t3 || $[57] !== t4 || $[58] !== t8) {
    t22 = <div className={styles.calculator__input}><div className={styles.calculator__input__inner}>{t3}{t4}{t8}{t13}{t18}{t21}</div></div>;
    $[53] = t13;
    $[54] = t18;
    $[55] = t21;
    $[56] = t3;
    $[57] = t4;
    $[58] = t8;
    $[59] = t22;
  } else {
    t22 = $[59];
  }
  return t22;
};
function _temp() {
  return 0;
}